export const toggleClass = (ref, classList, timeout = 1000) => {
  toggleClassArray(ref, classList)
  return setTimeout(() => toggleClassArray(ref, classList), timeout)
}

export const toggleClassArray = (ref, classList) => {
  if (!ref) {
    return
  }
  classList.forEach(className => {
    ref.classList.toggle(className)
  })
}
